// extracted by mini-css-extract-plugin
module.exports = {"container":"DateSelect_container__qVZ91","year":"DateSelect_year__cfI8R","day":"DateSelect_day__i_YLO","empty":"DateSelect_empty__5TgE_"};